import Image from 'next/legacy/image';
import { useTrustpilotSummary } from '@/utils/fetchers/trustpilot/summary';

const TrustpilotLogoBlock = () => {
  const { data } = useTrustpilotSummary();

  return (
    <div className="mb-6">
      <div className="text-[0px] leading-[0px] inline-block align-bottom pr-2">
        <Image
          src="https://images-static.trustpilot.com/api/logos/light-bg/logo.svg"
          alt="Trustpilot logo"
          height="47"
          width="150"
        />
      </div>
      <div className="text-[0px] leading-[0px] inline-block align-bottom mb-1">
        <Image
          src={`https://images-static.trustpilot.com/api/stars/${Math.round((data?.score?.stars || 4.5) * 2) / 2}/512x96.png`}
          alt={`Average star score of ${data?.score.stars || '4.6'} in trustpilot`}
          height="23"
          width="120"
        />
      </div>
    </div>
  );
};

export default TrustpilotLogoBlock;
